var path = '/templates/projects.heatmap/heatmap_list.html';
var html = "<div class=container><section><div class=row><div class=col-md-7><h3>ページ一覧</h3></div></div><div class=col-md-7><zc-heatmap-table pages=pages></zc-heatmap-table></div></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.heatmap/heatmap_list.html
// module id = 1409
// module chunks = 0